<template>

  <div class="macrofamily">

    <link-page-back v-if="!isPageHome" :page="'home'"/>

    <div class="description">
      <h1 class="ttl mt-0">{{data.descrizione}}</h1>
      <p class="p-desc">{{ $store.getters.contenuto('sezione_macro_cin') }}</p>
    </div>

    <div class="wrapper-data">
      <div class="content-data">
        <family-box v-for="(f, i) in data.family" :key="i" :family="f" :not_show="['custom']"/>
      </div>
    </div>
  </div>

</template>

<script>
export default{

  props: {
    data: {
      required: true
    }
  },

  data(){

    return {

    }

  },
  mounted: function(){
   // console.log(window.location);
  },

  computed: {
    isPageHome: function() {
      return window.location.pathname == '/';
    }
  }

}
</script>

<style scoped lang="scss">
.macrofamily {
  width: 100%;
}
.description{
  width: 100%;
}
.description h1 {
  font-weight: 500;
}
.content-data {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.content-data .box{
  width: 30%;
  margin: 10px 0;
}
.content-data .box:nth-child(3n + 2){
  margin: 10px 5%;
}

@media screen and (max-width: 700px)  {

  .content-data{
    justify-content: space-between;
  }
  .content-data .box{
    width: 49%;
    margin: 10px 0 !important;
  }

}

@media screen and (max-width: 390px) {

  .section .wrapper-data .content-data .box{
    width: 49%;
  }

}
</style>
